/* Optional, non-critical scripts only. Essential commerce scripts use defer. */
class LazyScriptLoader {
  constructor() {
    this.selector = 'script[data-loading="lazy"][data-src]';
    this.events = ['pointerdown','keydown','touchstart'];
    this.load = this.load.bind(this);
  }
  init() {
    if (!document.querySelector(this.selector)) return;
    this.events.forEach(event => document.addEventListener(event,this.load,{passive:true}));
    this.timer = setTimeout(this.load,5000);
  }
  load() {
    clearTimeout(this.timer);
    this.events.forEach(event => document.removeEventListener(event,this.load));
    document.querySelectorAll(this.selector).forEach(script => {
      script.async = false;
      script.src = script.dataset.src;
      script.dataset.loading = 'loaded';
      script.removeAttribute('data-src');
    });
  }
}
const esLazyLoader = new LazyScriptLoader();
if (document.readyState === 'complete') esLazyLoader.init();
else window.addEventListener('load',()=>esLazyLoader.init(),{once:true});
document.addEventListener('shopify:section:load',()=>esLazyLoader.load());
